export default "<div class=\"rmm-data-viewer\">\n</div>";